import { useTranslation } from 'react-i18next';

import { ListItem } from '@app/shared/ui/molecules/Roadmap';
import { ROADMAP_DATA } from '@app/shared/constants/roadmap';

export function List() {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-col gap-4">
      {ROADMAP_DATA.map((item) => (
        <ListItem key={item.translationKey} isCompleted={item.isCompleted}>
          {t(`roadmap.${item.translationKey}`)}
        </ListItem>
      ))}
    </ul>
  );
}
